<template>
  <CCardBody>
    <CDataTable class="custom-pagination" :items="ticketsData" :fields="fields" table-filter items-per-page-select
      :items-per-page="5" hover pagination>
      
      <template #ticketNumber="{ item }">
        <td>
          <div class="font-weight-bold text-primary">{{ item.ticketNumber || '-' }}</div>
        </td>
      </template>

      <template #reported_datetime="{ item }">
        <td>
          <div>{{ formatDate(item.userPart.dateTimeInformed) }}</div>
        </td>
      </template>

      <template #issue_user="{ item }">
        <td>
          <div>
            <span class="font-weight-bold">{{ getCategoryName(item) }}</span> | {{ getSubCategoryName(item) }}
            <div v-if="item.userPart && item.userPart.onBehalfOf" class="small text-danger mt-1">
              (แจ้งแทน: {{ item.userPart.onBehalfOf }})
            </div>
          </div>
        </td>
      </template>

      <template #rating="{ item }">
        <td class="text-center">
          <div style="white-space: nowrap;">
            <span v-for="n in 5" :key="n" style="font-size: 18px; margin: 0 1px;"
              :style="{ color: n <= getRatingStars(item) ? '#FFD700' : '#E4E5E9' }">
              ★
            </span>
          </div>
        </td>
      </template>

      <template #actions="{ item }">
        <td class="text-center">
          <CButton color="info" variant="outline" size="sm" class="circle-btn" @click="onRowClick(item)"
            title="ดูรายละเอียด">
            <CIcon name="cil-magnifying-glass" size="sm" />
          </CButton>
        </td>
      </template>
    </CDataTable>

  </CCardBody>
</template>

<style>
/* CSS เดิม (คงเดิม) */
.custom-pagination .page-item.active .page-link {
  background-color: #2ba9a5 !important;
  border-color: #2ba9a5 !important;
  color: #ffffff;
}

.custom-pagination .page-item .page-link {
  color: #414141;
}

.custom-pagination .page-item:not(.active) .page-link:hover {
  background-color: #f0f0f0;
}

.circle-btn {
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { mapGetters } from "vuex";

// ✅ เพิ่ม key: 'ticketNumber' และปรับความกว้างช่องอื่นเล็กน้อยให้พอดี
const fields = [
  { key: "ticketNumber", label: "เลขที่ใบแจ้งซ่อม", _style: "width:15%;" },
  { key: "reported_datetime", label: "วัน/เวลา แจ้ง", _style: "width:20%;" },
  { key: "issue_user", label: "รายละเอียด", _style: "width:40%;" },
  {
    key: "rating",
    label: "ความพึงพอใจ",
    _style: "width:15%; text-align:center;",
    class: "text-center"
  },
  { key: "actions", label: "", _style: "width:10%;", sorter: false, filter: false },
];

export default {
  name: "UHistoryTable",
  data() {
    return {
      ticketsData: [],
      fields,
    };
  },
  computed: {
    ...mapGetters("auth", ["profile"]),
  },
  mounted() {
    this.loadHistory();
  },
  methods: {
    async loadHistory() {
      try {
        const userId = this.profile?._id;
        if (!userId) {
          console.error("User ID not found");
          return;
        }

        const response = await fetch(
          `${process.env.VUE_APP_APP_URL}/ticket/user/${userId}/history`
        );
        const result = await response.json();

        if (result.success) {
          this.ticketsData = result.data;
        }
      } catch (error) {
        console.error("Failed to load history:", error);
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year} ${hours}:${minutes} น.`;
    },
    getCategoryName(item) {
      return item.userPart?.category?.departmentName || "ไม่ระบุ";
    },

    getSubCategoryName(item) {
      const sub = item.userPart?.subCategory;

      if (!sub) return "-";

      if (typeof sub === 'object') {
        return sub.subCategory || sub.name || sub.title || sub.subcategoryName || "-";
      }

      return sub;
    },

    getRatingStars(item) {
      return item.rating?.stars || 0;
    },
    onRowClick(item) {
      this.$emit("show-detail", item);
    },
  },
};
</script>